/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class SelectFormDialog extends NoboxEntityDialog<NoBoxCRM.FormRow, any> {
        protected getFormKey() { return Chat.SelectFormForm.formKey; }
        protected getIdProperty() { return NoBoxCRM.FormRow.idProperty; }
        protected getLocalTextPrefix() { return NoBoxCRM.FormRow.localTextPrefix; }
        protected getNameProperty() { return NoBoxCRM.FormRow.nameProperty; }

        protected form = new Chat.SelectFormForm(this.idPrefix);
        public IdRoom: number;
        public callback = (templateId,resultId) => {

        }
        protected updateLink() {
            var $form = this.form;
            var $this = this;
            $this.callback($form.FormTemplateId.value, $form.FormResultId.value)
            $this.dialogClose();
        }
        protected getEntityTitle(): string {
            return 'Select Form';
        }
        protected getToolbarButtons() {
            var buttons = [] as Serenity.ToolButton[];
            buttons.push({
                title: "Apply",
                icon: "fa-check text-blue",
                onClick: () => {
                    if (this.validateForm()) {
                        this.updateLink();
                    }
                }
            });
            return buttons;
        }
        constructor(container?: JQuery) {
            super(container);
        }

        protected updateInterface() {
            super.updateInterface();
            var $form = this.form;
        }

        protected onSaveSuccess(response) {
            super.onSaveSuccess(response);
            this.dialogClose();
        }
    }
}